module.exports = __webpack_public_path__ + "img/tiaomakuaishu02-450.6e27f737.png";